"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdatePaymentProviderEvent = exports.Name = void 0;
const Name = exports.Name = 'update-payment-provider';
const UpdatePaymentProviderEvent = exports.UpdatePaymentProviderEvent = Name;
